import Axios from 'axios';
import { ActionTypes } from 'utils/constants';
import { getEnvVar } from 'utils/get-env-var';
import { tripleWhaleAddToCart } from 'utils/triple-whale';

// Product id for the AddToCart fired when the join modal opens. The modal opens
// on the plans screen with nothing chosen yet, so there is no plan to name — only
// the /join/:plan route and a return from login arrive with one already set.
// Plan slugs are the same ids used for checkoutStarted/Purchase lineItems and for
// the server-side order line items, so the two stay joinable in Triple Whale.
const MEMBERSHIP_PRODUCT_ID = 'membership';

export const toggleJoinModal = () => {
    return (dispatch, getState) => {
        const state = getState();
        const open = state.user.join.modalOpen;
        
        document.body.style.overflow = open ? 'visible' : 'hidden';

        // opening, not closing — `open` is the state before this toggle applies.
        // Opening the join modal is the closest thing this site has to adding to
        // cart: it is the step between browsing and checkoutStarted.
        if (!open) {
            tripleWhaleAddToCart(state.user.join.plan || MEMBERSHIP_PRODUCT_ID);
        }

        if (open) {
            // wait a second before resetting the modal
            setTimeout(() => {
                dispatch({
                    type: ActionTypes.SET_JOIN_MODAL_SCREEN,
                    payload: 'plans'
                });
            }, 1000);
        }

        dispatch({
            type: ActionTypes.TOGGLE_JOIN_MODAL
        });
    };
};

export const setJoinModalScreen = screen => (
    {
        type: ActionTypes.SET_JOIN_MODAL_SCREEN,
        payload: screen
    }
);

export const setJoinPlan = payload => (
    {
        type: ActionTypes.SET_JOIN_PLAN,
        payload
    }
);

// Validate a plan coming from the /join/:plan route before starting checkout.
// The accepted plans are computed server-side (lifetime is only included when
// it's enabled), so an unknown or disabled plan lands on the invalid-plan screen
// instead of proceeding to a checkout the server would reject.
export const validateAndSetJoinPlan = ({ plan, nextScreen }) => async dispatch => {
    try {
        const { data } = await Axios.get(`${getEnvVar('API_BASE')}/accepted-plans`);
        const acceptedPlans = data?.plans || [];

        if (!acceptedPlans.includes(plan)) {
            dispatch(setJoinModalScreen('invalid-plan'));
            return;
        }

        dispatch(setJoinPlan({ plan, nextScreen }));
    } catch (e) {
        dispatch(setJoinModalScreen('invalid-plan'));
    }
};

// Reopens the join modal after a login that was launched from the join flow,
// jumping straight to the subscribe screen (which redirects to checkout) when a
// plan was already selected.
export const resumeCheckoutAfterLogin = () => (dispatch, getState) => {
    const { plan } = getState().user.join;

    dispatch(setJoinModalScreen(plan ? 'subscribe' : 'plans'));
    dispatch(toggleJoinModal());
};
